import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'

/** Path `d` through the committed anchors — a cubic wherever either end of a segment has a handle. */
export function buildCommittedPathD(points: PenAnchorPoint[]): string {
  if (points.length === 0) return ''
  const p0 = points[0]
  let d = `M ${p0.x} ${p0.y}`

  for (let i = 1; i < points.length; i++) {
    const prev = points[i - 1]
    const curr = points[i]
    const cp1x = prev.handleOut?.x ?? prev.x
    const cp1y = prev.handleOut?.y ?? prev.y
    const cp2x = curr.handleIn?.x ?? curr.x
    const cp2y = curr.handleIn?.y ?? curr.y

    if (prev.handleOut || curr.handleIn) {
      d += ` C ${cp1x} ${cp1y} ${cp2x} ${cp2y} ${curr.x} ${curr.y}`
    } else {
      d += ` L ${curr.x} ${curr.y}`
    }
  }

  return d
}

/** Rubber-band line/curve from the last anchor to the current cursor position. */
export function buildRubberBandD(last: PenAnchorPoint, mx: number, my: number): string {
  if (last.handleOut) {
    // Curved preview: use last point's handleOut as CP1, cursor position as (degenerate) CP2 and endpoint
    const cp1 = last.handleOut

    return `M ${last.x} ${last.y} C ${cp1.x} ${cp1.y} ${mx} ${my} ${mx} ${my}`
  }

  return `M ${last.x} ${last.y} L ${mx} ${my}`
}
